export const APP_ACCENT_COLORS = [
  "blue",
  "violet",
  "pink",
  "orange",
  "emerald",
  "teal",
  "gray",
] as const;

export type AppAccentColor = (typeof APP_ACCENT_COLORS)[number];

export const APP_REASONING_STYLES = [
  "precision",
  "balanced",
  "exploratory",
] as const;

export type AppReasoningStyle = (typeof APP_REASONING_STYLES)[number];

export type AppPreferences = {
  accentColor: AppAccentColor;
  reasoningStyle: AppReasoningStyle;
};

export const DEFAULT_APP_PREFERENCES: AppPreferences = {
  accentColor: "blue",
  reasoningStyle: "balanced",
};

export const APP_ACCENT_SWATCHES: Record<AppAccentColor, string> = {
  blue: "#2563eb",
  violet: "#7c3aed",
  pink: "#db2777",
  orange: "#c2410c",
  emerald: "#047857",
  teal: "#0f766e",
  gray: "#4b5563",
};

export function isAppAccentColor(value: unknown): value is AppAccentColor {
  return (
    typeof value === "string" &&
    APP_ACCENT_COLORS.some((color) => color === value)
  );
}

export function isAppReasoningStyle(
  value: unknown,
): value is AppReasoningStyle {
  return (
    typeof value === "string" &&
    APP_REASONING_STYLES.some((style) => style === value)
  );
}

export function normalizeAppPreferences(value: unknown): AppPreferences {
  const raw =
    value && typeof value === "object"
      ? (value as Record<string, unknown>)
      : {};

  return {
    accentColor: isAppAccentColor(raw.accentColor)
      ? raw.accentColor
      : DEFAULT_APP_PREFERENCES.accentColor,
    reasoningStyle: isAppReasoningStyle(raw.reasoningStyle)
      ? raw.reasoningStyle
      : DEFAULT_APP_PREFERENCES.reasoningStyle,
  };
}
